import styles from './OptionLang.module.css'
import { flags, Locale } from '@/i18n/constants'
import CheckIcon from '@/assets/img/Icon_Check.svg'
import Icon, { IconColors, IconTypes } from '../Icon/Icon'
import Flag, { FlagSize } from '../Flag/Flag'
import { useTranslations } from 'use-intl'
import { LangSelectorKinds, LangSelectorSizes } from './langSelectorTypes'
import { useWindowSize } from '@/hooks/useWindowsSize'
import { BREAKPOINTS } from '@/utils/constants'

interface OptionLangProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  locale: Locale
  selected: boolean
  parentKind: LangSelectorKinds
  parentSize: LangSelectorSizes
  setLocale: (nextLocale: Locale) => void
}

export default function OptionLang ({ locale, selected = false, parentKind, parentSize, setLocale }: OptionLangProps) {
  const t = useTranslations('General.languages')
  const { width } = useWindowSize()

  return (
    <button
      type={'button'}
      className={`${styles.langOption} ${selected ? 'selected' : ''}`}
      role="option"
      aria-selected={selected}
      data-testid={`OptionLang_${locale}`}
      onClick={() => setLocale(locale)}
    >
      <div className={styles.localeWrapper}>
        {(parentKind === LangSelectorKinds.FLAG || parentKind === LangSelectorKinds.TEXT_AND_FLAG) &&
          <Flag locale={locale as keyof typeof flags} size={FlagSize.SMALL} selected={selected} />
        }
        {(parentKind === LangSelectorKinds.TEXT || parentKind === LangSelectorKinds.TEXT_AND_FLAG) &&
          <span className={`bodyTextMediumStrong`}>
            {parentSize === LangSelectorSizes.LG
              ? t(locale)
              : width < BREAKPOINTS.DESKTOP ? t(locale) : locale.slice(0, 2).toUpperCase()
            }
          </span>
        }
      </div>

      {selected && <Icon className={styles.selectedIcon} icon={CheckIcon} type={IconTypes.SOLID} color={IconColors.DARK} />}
    </button>
  )
}